import { create, protoInt64 } from '@bufbuild/protobuf'
import {
  Timestamp,
  TimestampSchema,
  timestampDate,
} from '@bufbuild/protobuf/wkt'
import { TZDate } from '@date-fns/tz'
import { endOfMonth, format, parse, startOfDay, transpose } from 'date-fns'

export function parseJstDate(jstDate: string): Date {
  return transpose(
    new TZDate(parse(jstDate, 'yyyy-MM-dd', new Date()), 'Asia/Tokyo'),
    Date,
  )
}

export function formatYYYYMM(
  date: Date | string,
  delimiter?: '/' | '-',
): string {
  return format(
    new Date(date),
    delimiter !== undefined ? `yyyy${delimiter}MM` : 'yyyyMM',
  )
}

export function formatYYYYMMdd(
  date: Date | string,
  delimiter?: '/' | '-',
): string {
  return format(
    new Date(date),
    delimiter !== undefined ? `yyyy${delimiter}MM${delimiter}dd` : 'yyyyMMdd',
  )
}

export function formatYYYYMMddHHmmss(date: Date | string): string {
  return format(new Date(date), 'yyyy/MM/dd HH:mm:ss')
}

/**
 * Dateを受け取り、年月日だけを採用し強制的にJSTのZoneでのTimeStampに変換する
 */
export function formatDateToJSTYYYYMMddTimeStamp(date: Date): Timestamp {
  const yearString = String(date.getFullYear()).padStart(4, '0')
  const monthString = String(date.getMonth() + 1).padStart(2, '0')
  const dateString = String(date.getDate()).padStart(2, '0')

  const timeString = 'T00:00:00.000+09:00'

  const jstDate = new Date(
    `${yearString}-${monthString}-${dateString}${timeString}`,
  )

  const ms = jstDate.getTime()
  return create(TimestampSchema, {
    seconds: protoInt64.parse(Math.floor(ms / 1000)),
    nanos: (ms % 1000) * 1000000,
  })
}

/**
 * TimeStampを受け取り、年月日だけを採用して、JSTのDateとして変換する
 */
export function formatTimeStampToJSTYYYYMMddDate(timestamp: Timestamp): Date {
  // timestamp から toDate すると、ブラウザの new Date が呼び出される
  // https://github.com/bufbuild/protobuf-es/blob/a3e43df7843ff637221c587688e8d586f3a1367c/packages/protobuf/src/wkt/timestamp.ts#L37-L39
  const date = timestampDate(timestamp)

  // DB に保存されている timestamp を ブラウザ側の TZ 関係なく JST に変換する
  return transpose(new TZDate(date, 'Asia/Tokyo'), Date)
}

export function getEndOfMonthDay(date: Date): Date {
  return startOfDay(endOfMonth(date))
}
